import React from "react";
import { useParams, Link } from "react-router-dom";
import { Gift } from "lucide-react";
import Reveal from "../components/ui/Reveal";
import IconBox from "../components/ui/IconBox";
import AppStoreButtons from "../components/download/AppStoreButtons";
import SEO from "../components/seo/SEO";

export default function InvitePage() {
  const { code } = useParams();

  const openInApp = () => {
    window.location.href = `campusgenie://invite/${code}`;
  };

  return (
    <>
      <SEO
        title="Join CampusGenie"
        description="You've been invited to CampusGenie. Sign up with your invite code in the app to get started."
        url={`/invite/${code}`}
      />

      <section className="section" style={{ paddingTop: "calc(var(--header-height) + var(--space-12))" }}>
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: "center", gap: "var(--space-12)" }}>
            <Reveal>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: "var(--space-4)" }}>
                <IconBox icon={Gift} size={52} />
              </div>
              <span className="eyebrow">Invite</span>
              <h1 className="heading-1" style={{ marginBottom: "var(--space-4)" }}>
                Join CampusGenie
              </h1>
              <p className="body-large" style={{ marginBottom: "var(--space-6)" }}>
                You&apos;ve been invited to CampusGenie. Sign up with your invite code in the app to get started.
              </p>
              <p className="body-small" style={{ marginBottom: "var(--space-8)" }}>
                Invite code: <code className="legal-prose-code">{code}</code>
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "var(--space-3)" }}>
                <button type="button" className="btn btn-primary btn-lg" onClick={openInApp}>
                  Open in app
                </button>
                <Link to="/" className="btn btn-secondary btn-lg">
                  Continue on web
                </Link>
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <div className="contact-form-card" style={{ textAlign: "center" }}>
                <h3 className="heading-4" style={{ marginBottom: "var(--space-2)" }}>
                  Get the app
                </h3>
                <p className="body-small" style={{ marginBottom: "var(--space-6)" }}>
                  Download CampusGenie on your phone to use your invite.
                </p>
                <AppStoreButtons />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
